import {
  chatLlmStream,
  newStreamDocId,
  subscribeToLlmStream,
} from '../../services/llm';
import type { LlmGateway } from '../../domain/llm/api';

/** Compatibility Firebase adapter for the domain LLM port. The underlying
 * service remains available while callers migrate to this gateway. */
export const firebaseLlmGateway: LlmGateway = {
  createStreamDocId: () => newStreamDocId(),
  subscribeToStream: (streamDocId, callback) => subscribeToLlmStream(streamDocId, callback),
  startStream: (request) => chatLlmStream(request),
};
